import { useState } from "react";
import fuelGenieLogo from "@/assets/logo.png";

/** An organization's logo; if the file can't be loaded (removed, not uploaded yet) the Fuel Genie logo is shown. */
export function BrandLogo({ src, alt, className }: { src: string; alt: string; className?: string }) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const shown = failedSrc === src ? fuelGenieLogo : src;
  return <img src={shown} alt={alt} className={className} onError={() => setFailedSrc(src)} />;
}
